import { Entity } from "@jobilla/entity";

export class Subscription extends Entity {
  id!: string;
  pipelineId!: string;
  userId!: string;
}
